(() => {
  const callback = () => {
    const STORAGE_ITEM_KEY = 'customerType';

    const storedType = localStorage.getItem(STORAGE_ITEM_KEY);

    const customerTypes = { active: 'active', new: 'new', guest: 'guest' };
    const { customerType } = document.body.dataset;

    if (customerType === customerTypes.guest) {
      if (customerTypes[storedType]) {
        document.body.dataset.customerType = storedType;
      }
    } else {
      if (customerType !== storedType) {
        localStorage.setItem(STORAGE_ITEM_KEY, customerType);
      }
    }
  };

  window.addEventListener('DOMContentLoaded', callback);
})();
